<template>
    <div data-gtm-event="anteprima-mutuo" :data-immobile="immobileid" :data-source="source">
        <span :class="!showcalc ? 'mutuo_label' : ''" class="call-to-action1 prezzo-mut" v-if="!riservata" @click="showModal()" data-gtm-event="anteprima-mutuo" :data-immobile="immobileid" :data-source="source">
                A partire da {{ getRata(importo) }}€/mese
        </span>
    </div>
</template>
<script>
    import Modal from '../../classes/modal.class';

    export default {
        name: "CalcolaMutuoLabel",
        props: {
            importo:{
                required: false,
            },
            riservata:{
                type:[String, Boolean],
            },
            loan:{
                type:String,
            },
            size:{
                type:String,
            },
            name:{
                type:String,
            },
            mutuo:{
                type:Object,
            },
            showcalc: {
                default: true,
            },
            immobileid: {
                type: Number
            },
            source: {
                type:String,
            }
        },
        methods: {
            getRata(capitale) {

                if (this.loan) {
                    return this.loan;
                }
                else {
                    let capitaleImmobile = (capitale * this.tasso_optimal.ltv) / 100;

                    var numeroRateAnno = 12;
                    var durataMesi = this.tasso_optimal.durata * 12;
                    var numeroRate = durataMesi;
                    var tassoAnnuo = this.tasso_optimal.tasso / 100;
                    var rata = 0;

                    if (durataMesi > 0) {
                        var blocco1FormulaRata = Math.pow((1 + (tassoAnnuo / numeroRateAnno)), (durataMesi));
                        if (blocco1FormulaRata != 1)
                            rata = capitaleImmobile * blocco1FormulaRata * ((tassoAnnuo / numeroRateAnno) / (blocco1FormulaRata - 1));
                    }
                    let rata_length = this.getLengthOfRata(rata)+2;
                    rata = new Intl.NumberFormat('it-IT', {maximumSignificantDigits: rata_length}).format(rata)
                    return rata;
                }
            },
            getLengthOfRata(rata){
                let rataStr = rata.toString();
                let s = rataStr.split('.');
                if (s.length){
                    return s[0].length
                }
                else {
                    return rataStr.length
                }
            },
            parseMutKey() {
            },
            parseMutMatrix() {
               window.dtTassi_MUT.map( item => {

                   this.tassi_mutui.push( {
                       data: item[0],
                       tipotasso: item[1],
                       durata: item[2],
                       ltv: item[3],
                       tasso: item[4],
                       spread: item[5],
                       euribor: item[6]
                   });

               });
               this.calculateBestCase();
            },

            calculateBestCase(){
                let v_tipo_arr = this.tassi_mutui.filter(item => {
                    return item.tipotasso === this.tipotasso;
                })

                let durata_highest = v_tipo_arr.reduce(function(prev, curr) {
                    return prev.durata > curr.durata ? prev : curr;
                });

                let optimal_arr = v_tipo_arr.filter(item => {
                    return item.durata === durata_highest.durata;
                })

                let ftw_lowest = optimal_arr.reduce(function(prev, curr) {
                    return prev.ltv < curr.ltv ? prev : curr;
                });

                this.tasso_optimal = ftw_lowest;
            },

            showModal() {
                // La modale cambia a seconda dell'ente mutuo
                if(this.mutuo.is_credipass){
                    this.modal = new Modal({
                        name: this.name,
                        class: 'big-modal',
                        component: 'credipass-form',
                        closeButton: true,
                        padding: false,
                        callback: () => { this.$modal.hide(this.name); },
                        bind: {
                            immobileid: this.immobileid,
                            price: this.importo,
                            source: this.source,
                        }
                    });
                }
                else{
                    this.modal = new Modal({
                        name: this.name,
                        class: 'big-modal',
                        component: 'generic-mutuo-form',
                        padding: false,
                        closeButton: true,
                        callback: () => { this.$modal.hide(this.name); },
                        bind: {
                            immobileid: this.immobileid,
                            price: this.importo,
                            tipi_di_prodotto: this.mutuo.categorie_prodotto,
                            prodotti: this.mutuo.prodotti,
                            source: this.source,
                        }
                    });
                }
                this.$root.pushModal(this.modal);
            }
        },
        mounted() {
           this.parseMutKey();
           this.parseMutMatrix();
        },
        data() {
            return {
                tassi_mutui: [],
                tipotasso: "V",
                tasso_optimal: {},
                modal: null
            }
        }
    }
</script>

<style scoped lang="scss">
    .call-to-action1{
        cursor: pointer;
    }

    .mutuo_label {
        border:0;
        color: black !important;
        padding-left: 0 !important;
        cursor: auto !important;
    }
</style>
